import React from "react";
import { cn } from "@/lib/utils";

export const STATUS_META = {
  development: { label: "Development", cls: "bg-[color:rgba(255,171,0,0.14)] text-amber-600" },
  published: { label: "Published", cls: "bg-[color:rgba(0,194,168,0.14)] text-[color:var(--brand-mint)]" },
  hidden: { label: "Hidden", cls: "bg-[color:var(--surface-2)] text-[color:var(--ink-3)]" },
  archived: { label: "Archived", cls: "bg-[color:rgba(226,75,91,0.12)] text-[color:var(--danger)]" },
};

export function StatusBadge({ status, className }) {
  const m = STATUS_META[status || "development"] || STATUS_META.development;
  return (
    <span data-testid="dashboard-status-badge" className={cn("inline-flex items-center text-[10px] font-semibold px-2 py-0.5 rounded-full", m.cls, className)}>
      {m.label}
    </span>
  );
}

// Item 19: latest stored accessibility score (set on save / publish / audit). Green ≥90, amber ≥70, red below.
export function A11yScoreBadge({ a11y, onClick, className }) {
  if (!a11y || typeof a11y.score !== "number") return null;
  const tone = a11y.score >= 90 ? "bg-[color:rgba(0,194,168,0.14)] text-[color:var(--brand-mint)]"
    : a11y.score >= 70 ? "bg-[color:rgba(255,171,0,0.14)] text-amber-600" : "bg-[color:rgba(226,75,91,0.12)] text-[color:var(--danger)]";
  const title = `Accessibility ${a11y.score}/100 (WCAG 2.2 ${a11y.level || "AA"}) · ${a11y.errors || 0} error${a11y.errors === 1 ? "" : "s"}, ${a11y.warnings || 0} warning${a11y.warnings === 1 ? "" : "s"}${a11y.checked_at ? ` · checked ${new Date(a11y.checked_at).toLocaleString()}` : ""} — click to open the audit`;
  return (
    <button type="button" data-testid="dashboard-a11y-badge" data-score={a11y.score} title={title} aria-label={title}
      onClick={(e) => { e.stopPropagation(); onClick?.(); }}
      className={cn("inline-flex items-center gap-1 text-[10px] font-semibold px-2 py-0.5 rounded-full hover:ring-2 hover:ring-[color:var(--brand-ocean)]/40 transition-shadow", tone, className)}>
      <span aria-hidden="true">A11y</span>{a11y.score}
    </button>
  );
}
